import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
export default function HeaderActions({ children }) {
  const [host, setHost] = useState(null);
  useEffect(
    () => setHost(document.getElementById("workspace-header-actions")),
    [],
  );
  return host ? createPortal(children, host) : null;
}
